import { ChangeDetectionStrategy, Component, inject, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { ActivatedRoute, RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { SessionService } from "src/services/session.service";
import { PrefixWacComponent } from "../components/global/prefixes/impl/prefix-wac/prefix-wac.component";
import { DefaultComponent } from "../default.component";
@Component({
  selector: "app-resetpassword",
  imports: [MatProgressSpinnerModule, PrefixWacComponent, TranslateModule, RouterModule],
  templateUrl: "./resetpassword.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./resetpassword.component.less",
})
export class ResetPasswordComponent extends DefaultComponent implements OnInit {
  private session: SessionService;
  private route = inject(ActivatedRoute);

  public isLoading: boolean;
  public password: FormControl<string | null> | null;
  public passwordConfirm: FormControl<string | null> | null;

  public constructor() {
    super();
    this.session = inject(SessionService);

    this.isLoading = false;
    this.password = null;
    this.passwordConfirm = null;
  }

  public async ngOnInit(): Promise<void> {
    const requestid = this.route.snapshot.paramMap.get("id");
    if (!requestid) throw new Error("requestid is required");

    this.session.checkResetPassword(requestid);
  }

  public async recover(): Promise<void> {
    if (this.password && this.passwordConfirm) {
      this.isLoading = true;
      const passwordnew = this.password.value;
      const passwordrepeat = this.passwordConfirm.value;
      const requestid = this.route.snapshot.paramMap.get("id");

      try {
        if (!requestid) throw new Error("requestid is required");
        if (!passwordnew) throw new Error("passwordnew is required");
        if (!passwordrepeat) throw new Error("passwordrepeat is required");

        await this.session.resetPassword({
          passwordnew,
          passwordrepeat,
          requestid,
        });
      } catch (e) {
        console.error("[RECOVER ERROR]", e);
      } finally {
        this.isLoading = false;
      }
    } else {
      throw new Error("Undefined control");
    }
  }
}
